import {
  PB_SERVICE_LIST_GET_TRAIN_LIST_BEGIN,
  PB_SERVICE_LIST_GET_TRAIN_LIST_DISMISS_ERROR,
  PB_SERVICE_LIST_GET_TRAIN_LIST_FAILURE,
  PB_SERVICE_LIST_GET_TRAIN_LIST_SUCCESS,
} from './constants';

import CommonService from '../../../../services/commonService';
import axios from 'axios';

// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function getTrainList(args = {}) {
  return dispatch => {
    // optionally you can have getState as the second argument
    dispatch({
      type: PB_SERVICE_LIST_GET_TRAIN_LIST_BEGIN,
    });

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.
      const doRequest = axios.get(args.url, {
        headers: CommonService.getHeaders(),
      });
      doRequest.then(
        res => {
          dispatch({
            type: PB_SERVICE_LIST_GET_TRAIN_LIST_SUCCESS,
            data: formatServiceList(res.data),
          });
          resolve(res.data.code != 422 ? formatServiceList(res.data) : res.data);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        err => {
          dispatch({
            type: PB_SERVICE_LIST_GET_TRAIN_LIST_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissGetTrainListError() {
  return {
    type: PB_SERVICE_LIST_GET_TRAIN_LIST_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case PB_SERVICE_LIST_GET_TRAIN_LIST_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        getTrainListPending: true,
        getTrainListError: null,
      };

    case PB_SERVICE_LIST_GET_TRAIN_LIST_SUCCESS:
    // The request is success
    // return {
    //   ...state,
    //   getTrainListPending: false,
    //   getTrainListError: null,
    // };

    case PB_SERVICE_LIST_GET_TRAIN_LIST_FAILURE:
      // The request is failed
      return {
        ...state,
        getTrainListPending: false,
        getTrainListError: action.data.error,
      };

    case PB_SERVICE_LIST_GET_TRAIN_LIST_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        getTrainListError: null,
      };

    default:
      return state;
  }
}

const formatServiceList = response => {
  let schedules = response.body;
  let keys = schedules[0];
  let schedulesArr = [];
  for (let i = 1; i < schedules.length; i++) {
    let currentObj = {};
    for (let j = 0; j < schedules[i].length; j++) {
      currentObj[keys[j]] = schedules[i][j];
    }
    schedulesArr.push(currentObj);
  }

  let res = {
    routes: schedulesArr,
    stages: schedules.stage_names,
    success: true,
  };
  // if(payload.isReturn){
  //   yield put(fetchDataActionCreators.getServicesReturnSuccess(res));
  // }else{
  //   yield put(fetchDataActionCreators.getServicesSuccess(res));
  // }
  console.log(res);
  return res;
};



// WEBPACK FOOTER //
// ./src/features/Pasajebus/PasajebusServiceList/redux/getTrainList.js